import styled from '@emotion/styled';
import { css } from '@emotion/react';

import TimelineComponent from './index';
import CommentSection from '../Comments';

import { theme } from '../../../utils/theme';

const Container = styled.div`

`;

const TimelineWithComments = ({ resource, resource_id, title, events, manual = false, EventComponent, alternate = false, TimelineColor = theme.colors.primaryMid, expand = false, invalidate_queries = [] }) => {
  return (
    <Container>
      <TimelineComponent title={title} EventComponent={EventComponent} events={events} manual={manual} alternate={alternate} TimelineColor={TimelineColor} resource={resource} resource_id={resource_id} expand={expand} />
      <CommentSection resource={resource} resource_id={resource_id} invalidate_queries={invalidate_queries} />
    </Container>
  );
};

export default TimelineWithComments;